import { render, staticRenderFns } from "./GifIcon.vue?vue&type=template&id=daad9c90&"
import script from "./GifIcon.vue?vue&type=script&lang=js&"
export * from "./GifIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports